import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Col, Row } from "antd";
import { PATTERNS, USER_TYPE } from "constants/appConstant";
import { getIn, useFormik } from "formik";
import {
  doCreateSubscription,
  doUpdateSubscription,
  getSubscriptionDetail,
} from "stores/slices/subscriptions";
import { YupValidations } from "utils/validation";
import * as Yup from "yup";

import AppButton from "components/button";
import FormInput from "components/forms/components/formInput";
import ModalForm from "components/forms/components/modalForm";
// const { confirm } = Modal;

const SubscriptionForm = props => {
  const {
    openModal,
    onCancel,
    onCopy,
    setOpenModal,
    userType,
    cloneSubscription,
  } = props;
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const subscriptionDetail = useSelector(getSubscriptionDetail);

  const [isTurningOff, setIsTurningOff] = useState(false);
  const [isOpenModalTurnOff, setIsOpenModalTurnOff] = useState(false);
  const [selectedSubscription, setSelectedSubscription] = useState();

  const initialValues = {
    name: "",
    monthlyFee: 0,
    numberContact: 0,
    numberInc: 0,
    numberFee: 0,
    perSeatInc: 1,
    perSeatFee: 0,
    options: "",
    description: "",
    hide: false,
    default: false,
  };

  const onSubmitForm = async data => {
    setLoading(true);
    if (openModal === "ADD") {
      const request = {
        data: {
          name: data.name,
          monthlyFee: data.monthlyFee || 0,
          numberContact: data.numberContact || 0,
          numberInc: data.numberInc || 0,
          numberFee: data.numberFee || 0,
          perSeatInc: data.perSeatInc || 1,
          perSeatFee: data.perSeatFee || 0,
          options: data.options,
          description: data.description,
          hide: data.hide,
          currency: "AUD",
          makeDefault: data.default,
        },
        queries: {
          page: 1,
          size: 10,
        },
      };
      const response = await dispatch(doCreateSubscription(request));
      const { payload } = response;
      if (typeof payload === "object") {
        onCancel();
      }
    } else {
      if (subscriptionDetail.default && !data.default) {
        // confirm({
        //   title: t("subscriptions.confirmTurnOffDefaultTitle"),
        //   icon: <ExclamationCircleFilled />,
        //   content: t("subscriptions.confirmTurnOffDefault"),
        //   okText: t("button.ok"),
        //   cancelText: t("button.cancel"),
        //   onOk() {
        //     doUpdate(data);
        //   },
        // });
        setSelectedSubscription(data);
        setIsOpenModalTurnOff(true);
      } else {
        await doUpdate(data);
      }
    }
    setLoading(false);
  };

  const doUpdate = async data => {
    const request = {
      data: {
        name: data.name,
        monthlyFee: data.monthlyFee || 0,
        numberContact: data.numberContact || 0,
        numberInc: data.numberInc || 0,
        numberFee: data.numberFee || 0,
        perSeatInc: data.perSeatInc || 1,
        perSeatFee: data.perSeatFee || 0,
        options: data.options,
        description: data.description,
        isHide: data.hide,
        makeDefault: data.default,
      },
      id: subscriptionDetail.id,
    };
    const response = await dispatch(doUpdateSubscription(request));
    const { payload } = response;
    setIsTurningOff(false);
    setIsOpenModalTurnOff(false);
    if (typeof payload === "object") {
      setSelectedSubscription();
      onCancel();
    }
  };

  const inputItems = [
    {
      type: "text",
      key: "name",
      label: t("subscriptions.label.rateCardName"),
      placeholder: "subscriptions.label.rateCardNamePlchd",
      value: "",
      span: 24,
      style: {
        paddingBottom: 4,
      },
      config: {
        style: {
          fontSize: "14px",
        },
        styleLabel: {
          fontWeight: "bold",
        },
      },
      required: true,
      disabled: openModal === "VIEW",
    },
    {
      type: "number",
      key: "monthlyFee",
      label: t("subscriptions.label.monthlyCharge"),
      placeholder: "0",
      value: "",
      span: 12,
      style: {
        paddingBottom: 4,
        width: "100%",
      },
      config: {
        style: {
          width: "100%",
        },
        styleLabel: {
          fontWeight: "bold",
        },
        addonAfter: "AUD",
        addonBefore: "$",
        controls: false,
        disabled: openModal === "VIEW",
      },
    },
    {
      type: "number",
      key: "numberContact",
      label: t("subscriptions.label.includedContact"),
      placeholder: "0",
      value: "",
      span: 12,
      style: {
        paddingBottom: 4,
      },
      config: {
        style: {
          width: "100%",
        },
        styleLabel: {
          fontWeight: "bold",
        },
        controls: false,
        disabled: openModal === "VIEW",
      },
    },
    {
      type: "number",
      key: "numberInc",
      label: t("subscriptions.label.includedNumber"),
      placeholder: "0",
      value: "",
      span: 12,
      style: {
        paddingBottom: 4,
      },
      config: {
        style: {
          width: "100%",
        },
        styleLabel: {
          fontWeight: "bold",
        },
        controls: false,
        disabled: openModal === "VIEW",
      },
    },
    {
      type: "number",
      key: "numberFee",
      label: t("subscriptions.label.costPerNumber"),
      placeholder: "0",
      value: "",
      span: 12,
      style: {
        paddingBottom: 4,
      },
      config: {
        style: {
          width: "100%",
        },
        styleLabel: {
          fontWeight: "bold",
        },
        addonAfter: "AUD",
        addonBefore: "$",
        controls: false,
        disabled: openModal === "VIEW",
      },
    },
    {
      type: "number",
      key: "perSeatInc",
      label: t("subscriptions.label.includedSeats"),
      placeholder: "0",
      value: "",
      span: 12,
      style: {
        paddingBottom: 4,
      },
      config: {
        style: {
          width: "100%",
        },
        styleLabel: {
          fontWeight: "bold",
        },
        controls: false,
        disabled: openModal === "VIEW",
      },
    },
    {
      type: "number",
      key: "perSeatFee",
      label: t("subscriptions.label.costPerSeat"),
      placeholder: "0",
      value: "",
      span: 12,
      style: {
        paddingBottom: 4,
      },
      config: {
        style: {
          width: "100%",
        },
        styleLabel: {
          fontWeight: "bold",
        },
        addonAfter: "AUD",
        addonBefore: "$",
        controls: false,
        disabled: openModal === "VIEW",
      },
    },
    {
      type: "editor",
      key: "options",
      label:
        userType === USER_TYPE.USER
          ? t("subscriptions.label.options")
          : t("subscriptions.label.options_public"),
      placeholder: "subscriptions.label.textMessage",
      value: "",
      span: 24,
      style: {
        paddingBottom: 4,
        width: "100%",
        display: "grid",
        fontSize: "14px",
      },
      config: {
        styleLabel: {
          fontWeight: "bold",
        },
        style: {
          width: "100%",
          whiteSpace: "initial",
          display: "grid",
          wordBreak: "break-word",
          fontSize: "14px",
        },
        disabledStyle: {
          color: "rgba(0, 0, 0, 0.6)",
          cursor: "not-allowed",
          display: "grid",
          textDecoration: "none",
          fontSize: "14px",
        },
      },
      disabled: openModal === "VIEW",
    },
    {
      type: "textarea",
      key: "description",
      label: t("subscriptions.label.privateNote"),
      placeholder:
        openModal !== "VIEW" ? "subscriptions.label.textMessage" : "",
      value: "",
      span: 24,
      style: {
        paddingBottom: 4,
        width: "100%",
        fontSize: "14px",
      },
      config: {
        style: {
          width: "100%",
        },
        styleLabel: {
          fontWeight: "bold",
        },
        maxLength: 5001,
      },
      disabled: openModal === "VIEW",
      hidden: userType !== USER_TYPE.SUPER_ADMIN,
    },
    {
      type: "switch",
      key: "hide",
      label: t("subscriptions.label.hidden"),
      span: 24,
      style: {
        paddingBottom: 4,
        width: "100%",
      },
      config: {
        style: {
          width: "100%",
        },
        styleLabel: {
          fontWeight: "bold",
        },
      },
      disabled: openModal === "VIEW",
      hidden: userType !== USER_TYPE.SUPER_ADMIN,
    },
    {
      type: "switch",
      key: "default",
      label: t("subscriptions.label.makeDefault"),
      span: 24,
      style: {
        paddingBottom: 4,
        width: "100%",
      },
      config: {
        style: {
          width: "100%",
        },
        styleLabel: {
          fontWeight: "bold",
        },
      },
      disabled: openModal === "VIEW",
      hidden: userType !== USER_TYPE.SUPER_ADMIN,
    },
  ];

  const validationSchema = Yup.object().shape({
    name: YupValidations.name,
    monthlyFee: Yup.number()
      .min(0, "validate.min_value_0")
      .max(999999999, "validate.max_number_999999999")
      .nullable(),
    numberContact: Yup.number()
      .min(0, "validate.min_value_0")
      .max(999999999, "validate.max_number_999999999")
      .integer("validate.noDecimal")
      .nullable(),
    numberInc: Yup.number()
      .min(0, "validate.min_value_0")
      .max(999999999, "validate.max_number_999999999")
      .integer("validate.noDecimal")
      .nullable(),
    numberFee: Yup.number()
      .min(0, "validate.min_value_0")
      .max(999999999, "validate.max_number_999999999")
      .nullable(),
    perSeatInc: Yup.number()
      .min(1, "validate.min_value_1")
      .max(999999999, "validate.max_number_999999999")
      .integer("validate.noDecimal")
      .nullable(),
    perSeatFee: Yup.number()
      .min(0, "validate.min_value_0")
      .max(999999999, "validate.max_number_999999999")
      .nullable(),
    options: Yup.string().nullable(),
    description: Yup.string()
      .matches(PATTERNS.XSS_PATTERN, "validate.noxss")
      .max(5000, "validate.max_length_5000")
      .nullable(),
  });
  useEffect(() => {
    switch (openModal) {
      case "ADD":
        handleReset();
        if (cloneSubscription && cloneSubscription.name) {
          setValues(cloneSubscription);
        } else {
          setValues({ ...initialValues });
        }
        break;
      case "EDIT":
      case "VIEW":
        if (subscriptionDetail && subscriptionDetail.name) {
          handleReset();
          setValues(subscriptionDetail);
        } else {
          handleReset();
          setValues(initialValues);
        }
        break;
    }
  }, [subscriptionDetail, openModal]);

  const subscriptionForm = useFormik({
    initialValues: {
      name: "",
      monthlyFee: 0,
      numberContact: 0,
      numberInc: 0,
      numberFee: 0,
      perSeatInc: 1,
      perSeatFee: 0,
      options: "",
      description: "",
      hide: false,
      default: false,
    },
    validationSchema: validationSchema,
    onSubmit: onSubmitForm,
  });
  const { values, setFieldValue, handleSubmit, setValues, handleReset } =
    subscriptionForm;

  const handleTitleTurnOff = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <ExclamationCircleFilled style={{ color: "#faad14", fontSize: 24 }} />
        <span style={{ marginLeft: 10, fontSize: 16 }}>
          {t("subscriptions.confirmTurnOffDefaultTitle")}
        </span>
      </div>
    );
  };

  const handleTurnOffDefault = async () => {
    doUpdate(selectedSubscription);
  };
  return (
    <div>
      <FormInput
        items={inputItems.map(item => {
          item.label = t(item.label);
          if (item.key) {
            item.value = getIn(values, item.key);
          }
          return { ...item };
        })}
        form={subscriptionForm}
        onChange={setFieldValue}
        layout={"vertical"}
      />
      {openModal === "VIEW" && (
        <Row
          gutter={16}
          justify={userType === USER_TYPE.SUPER_ADMIN ? "space-between" : "end"}
        >
          <Col
            span={12}
            style={
              userType === USER_TYPE.USER && {
                display: "flex",
                justifyContent: "right",
              }
            }
          >
            <AppButton
              label={
                userType === USER_TYPE.SUPER_ADMIN
                  ? t("button.cancel")
                  : t("button.close")
              }
              color={"grey"}
              loading={loading}
              type="button"
              onClick={() => {
                onCancel();
                handleReset();
                setValues(initialValues);
              }}
              size={"medium"}
            />
          </Col>
          {userType === USER_TYPE.SUPER_ADMIN && (
            <Col
              span={12}
              style={{ display: "flex", justifyContent: "right", gap: "8px" }}
            >
              <AppButton
                label={t("button.edit")}
                color={"blue"}
                loading={loading}
                type="button"
                onClick={() => {
                  setOpenModal("EDIT");
                }}
                size={"medium"}
              />
              <AppButton
                label={t("button.copy")}
                color={"blue"}
                varient={"outlined"}
                onClick={() => {
                  onCopy(subscriptionDetail);
                }}
                size={"medium"}
              />
            </Col>
          )}
        </Row>
      )}
      {openModal === "EDIT" && (
        <Row gutter={16} justify={"space-between"}>
          <Col span={12}>
            <AppButton
              label={t("label.cancel")}
              color={"grey"}
              loading={loading}
              type="button"
              onClick={() => {
                onCancel();
                handleReset();
                setValues(initialValues);
              }}
              size={"medium"}
            />
          </Col>
          <Col
            span={12}
            style={{ display: "flex", justifyContent: "right", gap: "8px" }}
          >
            <AppButton
              label={t("button.copy")}
              color={"blue"}
              varient={"outlined"}
              onClick={() => {
                onCopy(subscriptionDetail);
              }}
              size={"medium"}
            />
            <AppButton
              label={t("label.save")}
              color={"blue"}
              loading={loading}
              type="submit"
              onClick={handleSubmit}
              size={"medium"}
            />
          </Col>
        </Row>
      )}
      {openModal === "ADD" && (
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            gap: "8px",
          }}
        >
          <AppButton
            label={t("label.cancel")}
            color={"grey"}
            loading={loading}
            type="button"
            onClick={() => {
              onCancel();
              handleReset();
              setValues(initialValues);
            }}
            size={"medium"}
          />
          <AppButton
            label={t("button.create")}
            color={"blue"}
            loading={loading}
            type="submit"
            onClick={handleSubmit}
            size={"medium"}
          />
        </div>
      )}
      <ModalForm
        isOpen={isOpenModalTurnOff}
        type="confirm"
        title={handleTitleTurnOff()}
        onCancel={() => {
          setIsOpenModalTurnOff(false);
        }}
        danger={true}
        maskClosable={false}
        footer={[
          <AppButton
            key="button"
            label={t("button.cancel")}
            color={"grey"}
            loading={isTurningOff}
            disabled={isTurningOff}
            htmlType="button"
            onClick={() => {
              setIsOpenModalTurnOff(false);
            }}
          />,
          <AppButton
            key="button"
            type="primary"
            color={"blue"}
            label={t("button.ok")}
            loading={isTurningOff}
            disabled={isTurningOff}
            onClick={() => {
              setIsTurningOff(true);
              handleTurnOffDefault(selectedSubscription);
            }}
          />,
        ]}
      >
        <div
          style={{ height: 50, marginTop: 10, marginLeft: 35, fontSize: 14 }}
        >
          {t("subscriptions.confirmTurnOffDefault")}
        </div>
      </ModalForm>
    </div>
  );
};

export default SubscriptionForm;
